import { css } from '@/styled-system/css';

export const photoCarouselNextButtonStyles = css.raw({
  insetInlineEnd: 0,
});
